<div class="flex flex-col items-center gap-4 max-w-[300px]">
    <p-inputotp class="mb-3" [(ngModel)]="code" [length]="6" [disabled]="loading()" (keydown.enter)="verifyCode()" />

    @if (showError()) {
    <p class="text-sm text-danger block text-center">
        That code didn't work. Codes refresh every 30 seconds, so check your app for the latest one and try again.
    </p>
    }

    <p-button styleClass="w-full mfa-verify-btn" label="Verify Code" severity="secondary" [loading]="loading()"
        [disabled]="code().length < 6 || loading()" (click)="verifyCode()" />

    <p-button styleClass="w-full" [text]="true" [label]="cancelLabel()" (click)="cancel()" />

    @if(showEnrollMessage()) {
    <p-divider class="mb-0" />
    <p class="!m-0 text-sm text-center text-neutral-500 max-w-[300px]">
        Keep your authenticator app safe - if you lose access to it, you'll need to
        <a href="https://www.defectwise.com.au/support" class="font-bold" target="_self">
            Contact Support&nbsp;<i class="pi pi-external-link" style="font-size: 0.6rem;"></i>&nbsp;
        </a> to regain access to your account.
    </p>
    } @else {
    <p class="!m-0 text-sm text-center text-neutral-500">
        Lost access to your authenticator app?
        <a href="https://www.defectwise.com.au/support" class="font-bold" target="_self">Contact Support</a>&nbsp;<i
            class="pi pi-external-link" style="font-size: 0.7rem;"></i>
    </p>
    }

</div>
